// extracted by mini-css-extract-plugin
module.exports = {"adminFloater":"src-admin-__Admin___adminFloater","adminContent":"src-admin-__Admin___adminContent","errorPopup":"src-admin-__Admin___errorPopup"};